import React from 'react';
import { Link } from 'react-router-dom';
import { CATEGORIES } from '../api/community';

// Renders 4 category tabs as Links. activeId highlights the current tab.
// Tabs route to /community/<id>. Used at top of CommunityPage.

export default function CategoryTabs({ activeId }) {
  return (
    <div style={{
      display: 'flex', gap: 4, flexWrap: 'wrap',
      borderBottom: '1px solid var(--border)',
      marginBottom: 24,
    }}>
      {CATEGORIES.map(c => {
        const isActive = c.id === activeId;
        return (
          <Link
            key={c.id}
            to={`/community/${c.id}`}
            style={{
              padding: '12px 20px',
              fontSize: '0.95rem',
              fontWeight: isActive ? 700 : 500,
              color: isActive ? 'var(--primary)' : 'var(--text-muted)',
              borderBottom: isActive ? '2px solid var(--primary)' : '2px solid transparent',
              marginBottom: -1, // overlap container border
              textDecoration: 'none',
              transition: 'color 0.15s',
            }}
          >
            <span style={{ marginRight: 6 }}>{c.emoji}</span>{c.label}
          </Link>
        );
      })}
    </div>
  );
}
